import { SVGProps } from 'react';
const SvgLinkVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 8v8M16 15v2a4 4 0 0 1-8 0v-2M16 9V7a4 4 0 0 0-8 0v2"
    />
  </svg>
);
export default SvgLinkVertical;
